import Model from 'vuex-model-store-generator'
import axios from '../../plugins/client'

import configRegulations from './regulations'
import configRegulationsSincResult from './regulations/sinc_result'
import configRegulationsFile from './regulations/file'
import configRegulationsTipo from './regulations/tipo'
import configRegulationsTiposSigla from './regulations/tipo_sigla'


export const Regulation = new Model(configRegulations, axios)
export const RegulationSincResult = new Model(configRegulationsSincResult, axios)
export const RegulationFile = new Model(configRegulationsFile, axios)
export const RegulationTipo = new Model(configRegulationsTipo, axios)
export const RegulationTiposSigla = new Model(configRegulationsTiposSigla, axios)